module.exports = __webpack_public_path__ + "fonts/helvetica-bold.woff.414243fb.ttf";